// ************************************ //
// Every page - framework functionality //
// ************************************ //

import $ from 'jquery';

// These modules are always used
import { NavLoad } from 'App/nav/load';
import { Social as SocialShare } from 'App/social/share';
import { Cookie } from 'App/cookie/cookie';
import { BackToTop } from 'App/back-to-top/back-to-top';

NavLoad.init();
SocialShare.init();
Cookie.init();
BackToTop.init();

// Publish resize and scroll events for other modules to use
import { publish } from 'Util/pubsub';
import { throttle } from 'Util/throttle';

const $window = $(window);
$window.on('resize', throttle(() => publish('/window/resize'), 250));
$window.on('scroll', () => publish('/window/scroll'));

// These modules are used often enough, or are small enough, that it's worth always loading them
import { Rte } from 'Controls/control.rte';
Rte.init();

import { expandCollapse } from 'App/expand-collapse/expand-collapse';
import { selectLink } from 'App/select-link/select-link';
import { VideoGroupLoad } from 'App/video-group/video-group';

import 'autocomplete';

// ********************************************************* //
// Controls - comment out any not being used by this project //
// ********************************************************* //

// Gallery Grid
import { GalleryGrid } from 'Controls/control.gallery-grid';
const $galleryGrids = $('.js-gallery-grid');

if ($galleryGrids.length) {
	GalleryGrid.init($galleryGrids);
}

// Gallery Rotator
import { GalleryRotator } from 'Controls/control.gallery-rotator';
const $galleryRotators = $('.js-gallery-rotator');

if ($galleryRotators.length) {
	GalleryRotator.init($galleryRotators);
}

// Google Maps
import { GoogleMap } from 'Controls/control.google-map';
GoogleMap.init();

// Locations List
import { LocationsList } from 'Controls/control.locations-list';
LocationsList.init();

// Logo Carousel
import { LogoCarousel } from 'Controls/control.logo-carousel';
const $logoCarousels = $('.js-logo-carousel');

if ($logoCarousels.length) {
	LogoCarousel.init($logoCarousels);
}

// Pathway Carousel
import { PathwayCarousel } from 'Controls/control.pathway-carousel';
const $pathwayCarousels = $('.js-pathway-carousel');

if ($pathwayCarousels.length) {
	PathwayCarousel.init($pathwayCarousels);
}

// Hero rotator
import { HerosRotator } from 'Controls/control.hero-rotator';
const $heroRotators = $('.js-home-hero-rotator');

if ($heroRotators.length) {
	HerosRotator.init($heroRotators);
}

// Testimonials Rotator
import { TestimonialsRotator } from 'Controls/control.testimonials-rotator';
const $testimonialsRotators = $('.js-testimonials-rotator');

if ($testimonialsRotators.length) {
	TestimonialsRotator.init($testimonialsRotators);
}

// Latest Insights
import { LatestInsights } from 'Controls/control.latest-insights';
const $latestInsights = $('.js-latest-insights');

if ($latestInsights.length) {
	LatestInsights.init($latestInsights);
}

// Pillars Scroller
import { PillarScroller } from 'Controls/control.pillars-scroller';
const $pillarscroller = $('.js-pillar-scroller');

if ($pillarscroller.length) {
	PillarScroller.init($pillarscroller);
}

// Expand and Collapse
if (document.querySelector('.js-expand-collapse')) {
	expandCollapse.init();
}

// Select Link
if (document.querySelector('.js-select-link')) {
	selectLink.init();
}

// Video Group
if (document.querySelector('.js-video-group')) {
	VideoGroupLoad.init();
}

// Scrollable filter
import { ScrollFilter } from 'Controls/control.scroll-filter';
if (document.querySelector('.js-scrolling-filters')) {
	ScrollFilter.init();
}

// Tool search autocomplete
import { ToolSearch } from 'Controls/control.tool-search';
if (document.querySelector('.js-tool-searchbox')) {
	ToolSearch.init();
}

//////////////////////////////////
// Any page, but not every page //
//////////////////////////////////

// Modal
if (document.querySelector('.js-modal')) {
	import(/* webpackChunkName: "Modal" */ 'App/modal/modal').then(({ modal }) => {
		modal.init({
			onShow: function ($modal) {
				var $rotators = $modal.find('.js-rotator');
				var thisFlick;
				$rotators.each(function (i, el) {
					thisFlick = $(el).data('flickity-instance');

					if (thisFlick) {
						thisFlick.resize();
					}
				});
			}
		});
	});
}

// Scroll Appear
if (document.querySelector('.js-scroll-appear')) {
	import(/* webpackChunkName: "ScrollAppear" */ 'App/scroll-appear/scroll-appear').then(({ scrollAppear }) => {
		scrollAppear.init();
	});
}

// Umbraco Forms
const $umbracoForms = $('.js-umbraco-form');
if ($umbracoForms.length) {
	import(/* webpackChunkName: "UmbracoForms" */ 'App/form/form.umbraco').then(({ UmbracoForms }) => {
		UmbracoForms.init();
	});
}

// Video Player
if (document.querySelector('.js-video-player')) {
	import(/* webpackChunkName: "VideoPlayer" */ 'App/video/video.player').then(({ VideoPlayer }) => {
		VideoPlayer.init();
	});
}

// Video Gallery
if (document.querySelector('.js-video-gallery')) {
	import(/* webpackChunkName: "VideoGallery" */ 'App/video/gallery').then(({ videoGallery }) => {
		videoGallery.init();
	});
}

// Event calendar add
if (document.querySelector('.js-calendar-link')) {
	import(/* webpackChunkName: "Calendar" */ 'App/event/calendar').then(({ Calendar }) => {
		Calendar.init();
	});
}

// Event calendar add
if (document.querySelector('.js-tabbed-content')) {
	import(/* webpackChunkName: "Calendar" */ 'App/tabbed-control/tabbed-control').then(({ TabbedControl }) => {
		TabbedControl.init();
	});
}

$(".js-home-scroller").click(function () {
	$('html,body').animate({
		scrollTop: $(".js-home-scroller").offset().top
	}, 'slow');
});




$(document).ready(function () {
	// Capture all of the dismissible notifications on the page
	const dismissibleNotifications = document.querySelectorAll('.js-notifications-item');

	// Save our local storage array which indicates which banners have already been hidden
	const hiddenNotifications = JSON.parse(localStorage.getItem('hiddenNotifications')) || [];

	//// Add .has-notifications if there are any hidden notifications
	Array.from(dismissibleNotifications).forEach((notification) => {

		// Check if the notification is in our hidden array in local storage. If not, then show it.
		const notificationName = notification.id;

		if (hiddenNotifications.includes(notificationName) === false) {
			notification.classList.remove('is-hidden');
		}
	});

	// Capture all of the dismiss buttons on the page and loop through them.
	const dismissButtons = document.querySelectorAll('.js-notifications-item__dismiss-button');

	Array.from(dismissButtons).forEach((button) => {

		// Save the notification that is associated with this button.
		const notificationName = button.dataset.dismiss;
		const notificationElement = document.querySelector('#' + notificationName);

		// Click action on this button
		button.addEventListener('click', () => {
			// Hide the notification from the page.
			//notificationElement.style.display = 'none';
			notificationElement.classList.add('is-hidden');

			// Indicate in local storage that this notification has been hidden.
			// Get the current array of hidden notifications from local storage.
			let hiddenNotifications = JSON.parse(localStorage.getItem('hiddenNotifications')) || [];

			// Add this notification name to the array
			hiddenNotifications.push(notificationName);

			// Set local storage with the new array info.
			localStorage.setItem('hiddenNotifications', JSON.stringify(hiddenNotifications));
		});
	});
});



// Members Notification panel open and close
$(document).on('click', function (event) {
	event.stopPropagation();
	// If the click target is NOT .c-notifications__wrapper or .c-notifications__button
	if (
		!$(event.target).closest('.c-notifications__wrapper').length &&
		!$(event.target).closest('.c-notifications__button').length
	) {
		$('.c-notifications__button').attr('aria-expanded', 'false');
		$('.c-notifications__wrapper').attr('aria-expanded', 'false');
	}
});

